import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import useAuthSync from '../../hooks/useAuthSync';

const MainLayout = ({ children }) => {
    // Sync role from backend — if admin changed it, localStorage updates & page reloads
    useAuthSync();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
            <Navbar />
            <main style={{ flex: 1, width: '100%' }}>
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default MainLayout;
